export default __webpack_public_path__ + "static/media/wild-rift-logo.bbb2e5be.png";